import { Injectable } from '@angular/core';
import { TrelloService } from 'app/trello/services/trello.service';
import { Observable, of, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private readonly USER_TOKEN_CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

  private _apiToken: string | undefined = undefined;

  private _userToken =
    this.trelloService.fetchUserToken()
      .pipe(
        shareReplay({
          bufferSize: 1,
          refCount: true,
          windowTime: this.USER_TOKEN_CACHE_DURATION,
        }),
      );

  constructor(
    private readonly trelloService: TrelloService,
  ) {
  }

  public get apiToken(): Observable<string> {

    if (this._apiToken === undefined) {
      throw new Error('No API token available');
    }

    return of(this._apiToken);
  }

  public set apiToken(
    apiToken: string,
  ) {
    if (this._apiToken !== undefined
      && this._apiToken !== apiToken) {
      throw new Error('Cannot replace existing API token');
    }

    this._apiToken = apiToken;
  }

  public get userToken(): Observable<string> {
    return this._userToken;
  }

}
